import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';

const PdfDeletePages = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const [pagesToDelete, setPagesToDelete] = useState('');

  const handleDeletePages = async () => {
    if (!pdfFile || !pagesToDelete) return;

    const arrayBuffer = await pdfFile.arrayBuffer();
    const originalPdf = await PDFDocument.load(arrayBuffer);
    const newPdf = await PDFDocument.create();

    const totalPages = originalPdf.getPageCount();

    // Convert user input like "2,4,5" into zero-based page indexes to delete
    const deleteSet = new Set(
      pagesToDelete
        .split(',')
        .map((n) => parseInt(n.trim(), 10) - 1)
        .filter((n) => !isNaN(n) && n >= 0 && n < totalPages)
    );

    for (let i = 0; i < totalPages; i++) {
      if (!deleteSet.has(i)) {
        const [page] = await newPdf.copyPages(originalPdf, [i]);
        newPdf.addPage(page);
      }
    }

    const newPdfBytes = await newPdf.save();
    const blob = new Blob([newPdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'pdf_pages_deleted.pdf';
    a.click();
  };

  return (
    <div>
    <div>
      <h2>Delete Pages from PDF</h2>
      <input type="file" accept="application/pdf" onChange={(e) => setPdfFile(e.target.files[0])} />
      <br /><br />
      <input
        type="text"
        placeholder="Pages to delete (e.g. 2,4,6)"
        value={pagesToDelete}
        onChange={(e) => setPagesToDelete(e.target.value)}
        style={{ width: '250px' }}
      />
      <br /><br />
      <button onClick={handleDeletePages} disabled={!pdfFile || !pagesToDelete}>
        Delete & Download
      </button>
    </div>
    <div className="content">

  <h2>Delete PDF Pages: Remove Unwanted Content Effortlessly</h2>

  <p>
    Sometimes a PDF contains unnecessary pages, mistakes, or confidential 
    information that needs to be removed. The Delete PDF Pages tool allows you 
    to selectively remove pages from your PDF, giving you a cleaner, more focused 
    document.
  </p>

  <p>
    Whether you’re preparing reports, presentations, contracts, or personal files, 
    deleting unwanted pages is quick, easy, and precise.
  </p>

  <h3>Why Delete Pages from a PDF?</h3>

  <ul>
    <li>Remove irrelevant or outdated content</li>
    <li>Keep documents concise and organized</li>
    <li>Eliminate confidential or sensitive pages</li>
    <li>Reduce file size by removing unnecessary pages</li>
    <li>Prepare PDFs for sharing, printing, or archiving</li>
  </ul>

  <h3>How the Delete PDF Pages Process Works</h3>

  <h4>1. Upload Your PDF</h4>
  <p>
    Select the PDF file you want to edit. The tool loads all pages and provides a 
    visual preview for easy selection.
  </p>

  <h4>2. Select Pages to Delete</h4>
  <p>
    Choose the pages you want to remove. You can select individual pages or 
    multiple pages at once.
  </p>

  <h4>3. Apply Deletion</h4>
  <p>
    After confirming your selection, click “Delete.” The tool removes the 
    selected pages and updates the PDF instantly.
  </p>

  <h3>Your Final PDF</h3>
  <p>
    You’ll receive a clean, organized PDF with only the pages you want to keep. 
    The new file is ready for downloading, sharing, printing, or further editing.
  </p>

</div>

    </div>
  );
};

export default PdfDeletePages;
// src/components/PdfDeletePages.js